import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import {
  GlobalDesignStyleGroup,
  StylesDerivedNativeActionNames,
} from '../../types';

enum MESSAGES_TEMPLATES_KEYS {
  DEFAULT = 'DEFAULT',
  SINGLE_ITEM = 'SINGLE_ITEM',
  WITH_COUNT = 'WITH_COUNT',
}

const TEXT_CONFIGS: Partial<
  Record<
    StylesDerivedNativeActionNames,
    Record<MESSAGES_TEMPLATES_KEYS, string>
  >
> = {
  [StylesDerivedNativeActions.textStyles]: {
    [MESSAGES_TEMPLATES_KEYS.DEFAULT]: 'globalDesign.tooltip.mutliple_styles',
    [MESSAGES_TEMPLATES_KEYS.SINGLE_ITEM]:
      'globalDesign.tooltip.text.mutliple_styles.no_display_name.one',
    [MESSAGES_TEMPLATES_KEYS.WITH_COUNT]:
      'globalDesign.tooltip.text.mutliple_styles.no_display_name.count',
  },
  [StylesDerivedNativeActions.cornerStyles]: {
    [MESSAGES_TEMPLATES_KEYS.DEFAULT]: 'globalDesign.tooltip.mutliple_styles',
    [MESSAGES_TEMPLATES_KEYS.SINGLE_ITEM]:
      'globalDesign.tooltip.corners.mutliple_styles.no_display_name.one',
    [MESSAGES_TEMPLATES_KEYS.WITH_COUNT]:
      'globalDesign.tooltip.corners.mutliple_styles.no_display_name.count',
  },
  [StylesDerivedNativeActions.shadowStyles]: {
    [MESSAGES_TEMPLATES_KEYS.DEFAULT]: 'globalDesign.tooltip.mutliple_styles',
    [MESSAGES_TEMPLATES_KEYS.SINGLE_ITEM]:
      'globalDesign.tooltip.shadows.mutliple_styles.no_display_name.one',
    [MESSAGES_TEMPLATES_KEYS.WITH_COUNT]:
      'globalDesign.tooltip.shadows.mutliple_styles.no_display_name.count',
  },
  [StylesDerivedNativeActions.borderStyles]: {
    [MESSAGES_TEMPLATES_KEYS.DEFAULT]: 'globalDesign.tooltip.mutliple_styles',
    [MESSAGES_TEMPLATES_KEYS.SINGLE_ITEM]:
      'globalDesign.tooltip.borders.mutliple_styles.no_display_name.one',
    [MESSAGES_TEMPLATES_KEYS.WITH_COUNT]:
      'globalDesign.tooltip.borders.mutliple_styles.no_display_name.count',
  },
};

export const getTooltipMessage = (
  t: (key: string, options?: any) => string,
  actionName: StylesDerivedNativeActionNames,
  group: GlobalDesignStyleGroup,
) => {
  const allGroups = [group, ...group.subsetGroups];
  const groupsDisplayNames: Set<string> = new Set();
  const componentDisplayNamesCount: Map<string, number> = new Map();
  const config = TEXT_CONFIGS[actionName];

  if (!config) {
    return '';
  }

  for (const group of allGroups) {
    if (group.displayName.group) {
      groupsDisplayNames.add(group.displayName.group);
    } else {
      componentDisplayNamesCount.set(
        group.displayName.component,
        (componentDisplayNamesCount.get(group.displayName.component) || 0) + 1,
      );
    }
  }

  const totalCount = groupsDisplayNames.size + componentDisplayNamesCount.size;
  const hasGroups = groupsDisplayNames.size > 0;
  const hasComponents = componentDisplayNamesCount.size > 0;

  if (!totalCount) {
    return '';
  }

  const formattedGroupsNames = hasGroups
    ? Array.from(groupsDisplayNames).join(', ')
    : null;
  const formattedComponentsNames = hasComponents
    ? Array.from(componentDisplayNamesCount.keys()).join(', ')
    : null;

  const totalAffectedComponentItems = Array.from(
    componentDisplayNamesCount.values(),
  ).reduce((sum, count) => sum + count, 0);

  if (totalCount === 1 && hasGroups) {
    return t(config[MESSAGES_TEMPLATES_KEYS.SINGLE_ITEM], {
      rootWidgetName: formattedGroupsNames,
    });
  }

  if (totalCount === 1 && hasComponents) {
    return totalAffectedComponentItems === 1
      ? t(config[MESSAGES_TEMPLATES_KEYS.SINGLE_ITEM], {
          rootWidgetName: formattedComponentsNames,
        })
      : t(config[MESSAGES_TEMPLATES_KEYS.WITH_COUNT], {
          count: totalAffectedComponentItems,
          rootWidgetName: formattedComponentsNames,
        });
  }

  if (totalCount > 1) {
    const concatenedList =
      formattedGroupsNames && formattedComponentsNames
        ? `${formattedGroupsNames}, ${formattedComponentsNames}`
        : formattedGroupsNames || formattedComponentsNames;

    return t(config[MESSAGES_TEMPLATES_KEYS.DEFAULT], {
      groupDisplayName: `\n${concatenedList}`,
    });
  }
  return '';
};
